var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "pega-break" }, [
    _c("div", { staticClass: "boss-table-title pega-print-title" }, [
      _c("div", { staticClass: "pega-ta-right" }, [
        _c("span", { attrs: { "data-test": "company-name" } }, [
          _vm._v(_vm._s(_vm.entryCompanyName) + "\n        "),
          _vm.headerUserName
            ? _c("span", { attrs: { "data-test": "header-info" } }, [
                _c("br"),
                _vm.isDuplicatedEntries
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "boss-status-label pega-status-label pega-status-label-top-0",
                        attrs: { "data-test": "label-duplicated-entries" },
                      },
                      [_vm._v("重複応募\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isSimpleEntryForm
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "boss-status-label pega-status-label pega-status-label-top-0",
                        attrs: { "data-test": "label-entry-form" },
                      },
                      [_vm._v("自己PR不要\n          ")]
                    )
                  : _vm._e(),
                _vm._v(
                  "\n          応募者：" +
                    _vm._s(_vm.headerUserName) +
                    "様\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _c("span", { attrs: { "data-test": "updated-date" } }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm._f("formatDate")(_vm.resume.updatedDate)) +
                "現在\n        "
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c("div", { staticClass: "boss-table-wrap" }, [
        _c(
          "table",
          {
            staticClass:
              "boss-table-4 boss-table-4-responsive pega-th-color-important pega-print-resume-table",
          },
          [
            _c("tr", [
              _c("th", [_vm._v("応募求人")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "4", "data-test": "job-name" } }, [
                _vm._v(_vm._s(_vm.resume.jobName)),
              ]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass:
                    "boss-table-4-plain boss-resume-sheet-photo-space-cell padding-bottom-1",
                  attrs: { rowspan: "6" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "boss-resume-sheet-photo-space-layout" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { attrs: { "data-test": "user-id" } }, [
                        _vm._v("会員ID：" + _vm._s(_vm.resume.userId)),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("応募日")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "4", "data-test": "entry-date" } }, [
                _vm._v(_vm._s(_vm._f("formatDateTime")(_vm.resume.entryDate))),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("フリガナ")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "4", "data-test": "name-kana" } }, [
                _vm._v(_vm._s(_vm.userNameKana)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("氏名")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "4", "data-test": "name" } }, [
                _vm._v(_vm._s(_vm.userName)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("生年月日")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "2", "data-test": "birthday" } }, [
                _vm._v(
                  _vm._s(_vm._f("formatDate")(_vm.resume.birthday)) +
                    " " +
                    _vm._s(_vm.ageLabel)
                ),
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("性別")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "text-nowrap",
                  attrs: { "data-test": "gender" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(_vm.resume.gender)
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { rowspan: "2" } }, [_vm._v("現住所")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "5", "data-test": "zip" } }, [
                _vm._v(_vm._s(_vm.formatZip)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { attrs: { colspan: "5", "data-test": "address" } }, [
                _vm._v(_vm._s(_vm.resume.address)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("電話番号")]),
              _vm._v(" "),
              _c("td", { attrs: { "data-test": "tel", colspan: "2" } }, [
                _vm._v(
                  _vm._s(_vm._f("parseBlankForDefaultValue")(_vm.resume.tel))
                ),
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("携帯電話番号")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "text-nowrap",
                  attrs: { colspan: "2", "data-test": "mobile" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(_vm.resume.mobile)
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("メールアドレス")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "pega-break",
                  attrs: { colspan: "2", "data-test": "email" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(_vm.resume.email)
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("th", [_vm._v("携帯メールアドレス")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "pega-break",
                  attrs: { colspan: "2", "data-test": "email-mobile" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(
                        _vm.resume.emailMobile
                      )
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticClass: "text-center text-unset-mobile",
                  attrs: { "data-test": "graduated-date" },
                },
                [_vm._v(_vm._s(_vm.graduatedSchoolDate))]
              ),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "5", "data-test": "graduated-school" } },
                [
                  _vm._v(
                    _vm._s(_vm.resume.graduatedSchool.name) +
                      " " +
                      _vm._s(_vm.resume.graduatedSchool.department) +
                      " 卒業 (最終学歴:" +
                      _vm._s(
                        _vm._f("parseBlankForDefaultValue")(
                          _vm.resume.educationalBackgroundName
                        )
                      ) +
                      ")\n            "
                  ),
                  _c(
                    "div",
                    {
                      attrs: {
                        "data-test": "graduated-school-department-category",
                      },
                    },
                    [
                      _vm._v(
                        "\n              学部・学科コード: " +
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.graduatedSchool.departmentCategory
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm.resume.careerResumes.length
              ? _vm._l(_vm.resume.careerResumes, function (careerResume, i) {
                  return _c("tr", { key: i }, [
                    _c(
                      "td",
                      {
                        staticClass: "text-center text-unset-mobile",
                        attrs: { "data-test": "working-period-" + i },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.workingPeriod(
                              careerResume.firstYear,
                              careerResume.firstMonth
                            )
                          ) +
                            "～" +
                            _vm._s(
                              _vm.workingPeriod(
                                careerResume.lastYear,
                                careerResume.lastMonth
                              )
                            )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        attrs: {
                          "data-test": "career-company-name-" + i,
                          colspan: "5",
                        },
                      },
                      [_vm._v(_vm._s(careerResume.companyName))]
                    ),
                  ])
                })
              : [_vm._m(6)],
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("学歴補足事項")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "pega-pre-wrap",
                  attrs: {
                    colspan: "5",
                    "data-test": "educational-background-note",
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(
                        _vm.resume.graduatedSchool.educationalNote
                      )
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("就業状況")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "3", "data-test": "working-status-name" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(
                        _vm.resume.workingStatusName
                      )
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("th", [_vm._v("転職の回数")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "1", "data-test": "change-job-count" } },
                [_vm._v(_vm._s(_vm.changeJobCount))]
              ),
            ]),
            _vm._v(" "),
            _vm._m(9),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("資格")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "5", "data-test": "licenses" } }, [
                _vm._v(_vm._s(_vm.licenses)),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("その他の資格")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "pega-pre-wrap",
                  attrs: { colspan: "5", "data-test": "other-license" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("parseBlankForDefaultValue")(
                        _vm.resume.otherLicense
                      )
                    )
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm._m(10),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("TOEIC")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { "data-test": "toeic", colspan: "2" } },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.toeic,
                              "点"
                            )
                          )
                        ),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("th", [_vm._v("TOEFL")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "2", "data-test": "toefl" } },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.toefl,
                              "点"
                            )
                          )
                        ),
                      ],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("英語スキル")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { "data-test": "english-skill", colspan: "2" } },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.englishSkill
                            )
                          )
                        ),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("th", [_vm._v("英語以外の語学スキル")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  attrs: { colspan: "2", "data-test": "other-language-skill" },
                },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [_vm._v(_vm._s(_vm.otherLanguageSkillsText))],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm._m(11),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("志望動機・自己PR")]),
              _vm._v(" "),
              _vm.isSimpleEntryForm
                ? _c(
                    "td",
                    { attrs: { "data-test": "self-pr-simple", colspan: "5" } },
                    [_c("hidden-notice")],
                    1
                  )
                : _c("td", {
                    staticClass: "pega-pre-wrap",
                    attrs: { colspan: "5", "data-test": "self-pr" },
                    domProps: { textContent: _vm._s(_vm.selfPr) },
                  }),
            ]),
            _vm._v(" "),
            _vm._m(12),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("本人希望記入欄")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "5" } }, [
                _c(
                  "dl",
                  { staticClass: "boss-definition-list" },
                  [
                    _c("dt", [_vm._v("希望勤務地：")]),
                    _vm._v(" "),
                    _c("dd", { attrs: { "data-test": "desired-prefecture" } }, [
                      _vm._v(_vm._s(_vm.desiredPrefecture)),
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("希望年収：")]),
                    _vm._v(" "),
                    _c("dd", { attrs: { "data-test": "desired-salary" } }, [
                      _vm._v(_vm._s(_vm.desiredSalary)),
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("希望転職時期：")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { attrs: { "data-test": "desired-change-period" } },
                      [_vm._v(_vm._s(_vm.desiredChangePeriod))]
                    ),
                    _vm._v(" "),
                    _c("dt", [_vm._v("その他の希望：")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      { attrs: { "data-test": "desired-other" } },
                      [
                        _vm.isSimpleEntryForm
                          ? _c("hidden-notice")
                          : [_vm._v(_vm._s(_vm.desiredOther))],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.resume.questionsAnswers,
                      function (questionsAnswer, i) {
                        return [
                          _c(
                            "dt",
                            {
                              key: "dt-" + i,
                              staticClass: "pega-pre-wrap",
                              attrs: { "data-test": "dt-" + i },
                            },
                            [_vm._v(_vm._s(questionsAnswer.question) + "：")]
                          ),
                          _vm._v(" "),
                          _c(
                            "dd",
                            {
                              key: "dd-" + i,
                              staticClass: "pega-pre-wrap",
                              attrs: { "data-test": "dd-" + i },
                            },
                            [_vm._v(_vm._s(questionsAnswer.answer))]
                          ),
                        ]
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(13),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("未既婚")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { "data-test": "marriage" } },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.marriage
                            )
                          )
                        ),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("th", { staticClass: "unset" }, [_vm._v("子供の有無")]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { "data-test": "child-status" } },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.childStatus
                            )
                          )
                        ),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("th", { staticClass: "unset" }, [
                _vm._v("転居を伴う転職可否"),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { "data-test": "home-moving" } },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.homeMoving
                            )
                          )
                        ),
                      ],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("その他補足説明")]),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticClass: "pega-pre-wrap",
                  attrs: { "data-test": "other-supplement", colspan: "5" },
                },
                [
                  _vm.isSimpleEntryForm
                    ? _c("hidden-notice")
                    : [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseBlankForDefaultValue")(
                              _vm.resume.otherSupplement
                            )
                          )
                        ),
                      ],
                ],
                2
              ),
            ]),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout boss-layout-gap-between" }, [
      _c(
        "div",
        { staticClass: "boss-resume-sheet-title pega-resume-sheet-title" },
        [_vm._v("履歴書")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-boss-only-pc" }, [
      _c("div", { staticClass: "boss-resume-sheet-photo-space" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "4" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("th", { attrs: { colspan: "6" } }, [_vm._v("学歴")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "6" } }, [_vm._v("職務経歴（概略）")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { "data-test": "working-period-0" } }, [
        _vm._v("未登録"),
      ]),
      _vm._v(" "),
      _c(
        "td",
        { attrs: { "data-test": "career-company-name-0", colspan: "5" } },
        [_vm._v("未登録")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td"),
      _vm._v(" "),
      _c("td", { staticClass: "boss-right", attrs: { colspan: "5" } }, [
        _vm._v("以上"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "boss-table-4-space", attrs: { colspan: "6" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }